import { defineMessages } from 'react-intl';

export default defineMessages({
  searchVideo: {
    id: 'widget.search-bar.search-video',
    defaultMessage: 'Search video...',
  },
});



// WEBPACK FOOTER //
// ./src/widget/components/search-bar/translations.js